import React from "react";
import { motion } from "framer-motion";
import { Search, LayoutGrid, Users, Rocket, GraduationCap } from "lucide-react";
import { SECTION } from "@/constants/testIds";
import { useI18n } from "@/i18n/I18nContext";

const ICONS = [Search, LayoutGrid, Users, Rocket, GraduationCap];

export default function Methodology() {
  const { t } = useI18n();
  const m = t.method;

  return (
    <section
      id="methode"
      data-testid={SECTION.methodology}
      className="section-y bg-slate-50/70 relative"
    >
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="text-overline">{m.overline}</span>
          <h2 className="mt-4 font-display font-semibold text-navy text-3xl sm:text-4xl lg:text-5xl leading-[1.1]">
            {m.title}
          </h2>
        </div>

        <div className="mt-16 relative">
          <div className="hidden lg:block absolute left-0 right-0 top-12 h-px bg-gradient-to-r from-transparent via-navy/20 to-transparent" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 lg:gap-4">
            {m.steps.map((s, i) => {
              const Icon = ICONS[i] || Search;
              return (
                <motion.div
                  key={s.title}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  data-testid={`method-step-${i + 1}`}
                  className="relative"
                >
                  <div className="relative z-10 flex items-center gap-3 lg:flex-col lg:items-start">
                    <div className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white border-2 border-navy text-navy">
                      <Icon className="h-5 w-5" />
                    </div>
                    <span className="font-mono text-xs text-slate-400">
                      {m.stepWord} {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                  <h3 className="mt-4 font-display text-xl font-semibold text-navy">{s.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
